// Module
var code = "<div class=\"modal-header\"> <h3>Session Expired</h3> </div> <div class=\"modal-body\"> <p> You have been idle for 20 minutes and have been logged out due to inactivity. </p> </div> ";
// Exports
module.exports = code;